<!-- Pied de page commun à toutes les pages : liens vers les pages légales (RGPD) -->
<template>
  <footer class="app-footer">
    <span>© Wedoomotion {{ year }}</span>
    <router-link to="/mentions-legales">Mentions légales</router-link>
    <router-link to="/confidentialite">Confidentialité</router-link>
    <router-link to="/cgu">CGU</router-link>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',

  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.app-footer {
  /* Au-dessus des fonds en position fixe (vidéo de la page d'accueil) */
  position: relative;
  z-index: 1;
  margin-top: auto;
  padding: 16px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 20px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
}

.app-footer a {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
}

.app-footer a:hover {
  color: #ffffff;
  text-decoration: underline;
}
</style>
